import axios from "axios";
import { WithdrawalRequestActions } from "./withdrawalRequestAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

//get all Requested Withdrawal Token list
export const getRequestedWithdrawalToken = (search, searchText) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      let {
        skip,
        limit,
        fromDate,
        toDate,
        transaction_type,
        searchText,
      } = getState().withdrawalRequest;
      dispatch(WithdrawalRequestActions.getWithdrawalRequestStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/getRequestedWithdrawalToken`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          search: searchText,
          skip,
          limit,
          fromDate,
          toDate,
          request_type: transaction_type?.value,
        },
      });
      if (data.statusCode === 200) {
        return dispatch(
          WithdrawalRequestActions.getWithdrawalRequestSuccess(data)
        );
      }
      dispatch(WithdrawalRequestActions.getWithdrawalRequestError());
    } catch (error) {
      dispatch(WithdrawalRequestActions.getWithdrawalRequestError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

// get only Pending withdrawal count (no pagination)
export const getPendingWithdrawalCount = () => {
  return async (dispatch) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/getRequestedWithdrawalToken`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          skip: 0,
          limit: 1,
          request_type: "pending",
        },
      });
      if (data.statusCode === 200) {
        const count = data?.data?.count || 0;
        dispatch(WithdrawalRequestActions.setPendingWithdrawalCount(count));
      }
    } catch (error) {
      // fail silently; badge is non-critical
      dispatch(WithdrawalRequestActions.setPendingWithdrawalCount(0));
    }
  };
};

export const updateTokenTransactionAsync = (values, transaction_id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(WithdrawalRequestActions.updateWithdrawalRequestStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/tokentransactions/editTokenTransaction/${transaction_id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });

      if (data.statusCode === 200 || data.statusCode === 201) {
        //dispatch(WithdrawalRequestActions.updateWithdrawalRequestSuccess(data));
        // if (data.data.success) {
        //   return dispatch(
        //     showSuccessSnackbar("success", data.data.message, 3000)
        //   );
        // } else {
        //   return dispatch(
        //     showSuccessSnackbar("error", data.data.message, 3000)
        //   );
        // }

        dispatch(WithdrawalRequestActions.updateWithdrawalRequestSuccess(data));
        return dispatch(
          showSuccessSnackbar(
            "success",
            "Withdrawal Status Updated Successfully",
            3000
          )
        );
      }
      dispatch(WithdrawalRequestActions.updateWithdrawalRequestError());
      return dispatch(showSuccessSnackbar("error", data.data, 3000));
    } catch (error) {
      dispatch(WithdrawalRequestActions.updateWithdrawalRequestError(error));
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
